import React from 'react';
import { Instagram, Linkedin, Youtube } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import styles from './footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>

      <div className={styles.container}>
        {/* Top Section */}
        <div className={styles.topSection}>
          {/* Logo Section */}
          <div className={styles.logoSection}>
            <a href="/">
              <img className={styles.logo} src="/assets/logo.png" alt="ElectroWiz Logo" />
            </a>
          </div>

          {/* Navigation Links Section */}
          <div className={styles.linksSection}>
            <h3 className={styles.sectionTitle}>Navigation</h3>
            <ul className={styles.linksList}>
              <li><a href="/manufacturers" className={styles.link}>Manufacturers</a></li>
              <li><a href="/service" className={styles.link}>Services</a></li>
              <li><a href="/aboutUs" className={styles.link}>About Us</a></li>
              <li><a href="/contact" className={styles.link}>Contact</a></li>
            </ul>
          </div>

          {/* Tools Section */}
          <div className={styles.linksSection}>
            <h3 className={styles.sectionTitle}>Tools</h3>
            <ul className={styles.linksList}>
              <li><a href="/bomManage" className={styles.link}>BOM Tool</a></li>
              <li><a href="/crossRefer" className={styles.link}>Cross Reference Tool</a></li>
              <li><a href="/exInventoryBuyItem" className={styles.link}>Excess Inventory Tool</a></li>
              <li><a href="/scheduleCart" className={styles.link}>Schedule Tool</a></li>
              <li><a href="/wizardUpload" className={styles.link}>Wizard Tool</a></li>
            </ul>
          </div>

          {/* Newsletter Section */}
          <div className={styles.linksSection}>
            <h3 className={styles.sectionTitle}>Newsletter</h3>
            <p className={styles.description}>Stay updated with our latest news and offers</p>
            <div className={styles.newsletterForm}>
              <input
                type="email"
                placeholder="Enter your email"
                className={styles.newsletterInput}
              />
              <button className={styles.newsletterButton}>Subscribe</button>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className={styles.divider}></div>

        {/* Bottom Section */}
        <div className={styles.bottomSection}>
          {/* Copyright */}
          <div className={styles.copyright}>
            <h4 className={styles.copyrightTitle}>Copyright by</h4>
            <a href="https://www.electrowiz.in" target="_blank" rel="noopener noreferrer" className={styles.copyrightText}> www.electrowiz.in</a>
          </div>

          {/* Contact */}
          <div className={styles.contact}>
            <h4 className={styles.contactTitle}>Contact Us</h4>
            <p className={styles.contactText}>+91 8088308500</p>
          </div>

          {/* Address */}
          <div className={styles.address}>
            <h4 className={styles.addressTitle}>Address</h4>
            <p className={styles.addressText}>First Floor, No. 45, 80 Feet Rd, Kathreguppe, Banashankari 3rd Stage <br /> Bengaluru, Karnataka 560085</p>
          </div>

          {/* Social Media */}
          <div className={styles.socialMedia}>
            <a href="https://www.instagram.com/electrowiz.in?igsh=MWM2a2RkY2dwaXN1bg%3D%3D" target='_blank' rel="noopener noreferrer" className={styles.socialLink}>
              <Instagram size={20} />
            </a>
            <a href="https://www.linkedin.com" target='_blank' rel="noopener noreferrer" className={styles.socialLink}>
              <Linkedin size={20} />
            </a>
            <a href="https://www.youtube.com/@Electrowiz-Comp" target='_blank' rel="noopener noreferrer" className={styles.socialLink}>
              <Youtube size={20} />
            </a>
            <a href="https://wa.me/918088308500" target='_blank' rel="noopener noreferrer" className={styles.socialLink}>
              <FontAwesomeIcon icon={faWhatsapp} size="lg" />
            </a>
          </div>
        </div>
      </div>

    </footer >
  );
};

export default Footer;